import React from "react";
import styled from "styled-components";
// Components
import Lightroom from "react-lightbox-gallery";
// Assets

import g1 from "../../assets/img/cp1.jpg";
import g2 from "../../assets/img/cp2.jpg";
import g3 from "../../assets/img/cp3.jpg";
import g4 from "../../assets/img/cp4.jpg";
import g5 from "../../assets/img/cp5.jpg";
import g6 from "../../assets/img/cp6.jpg";
import g7 from "../../assets/img/cp7.jpg";
import g8 from "../../assets/img/cp8.jpg";
export default function ChannelPartners() {
  var images = [
    {
      src: g1,
      desc: "Our Industry Associations IT Infrastructur",
    },
    {
      src: g2,
      desc: "Our Industry Associations Security Surveillance & Access Control Systems",
    },
    {
      src: g3,
      desc: "Our Industry Associations Hospital Lightings",
    },
    {
      src: g4,
      desc: "Our Industry Associations Hospital Furniture's",
    },
    {
      src: g5,
      desc: "Our Industry Associations Hospital surgical & non-surgical Instruments",
    },
    {
      src: g6,
      desc: "Our Industry Associations Medical Devices",
    },
    {
      src: g7,
      desc: "Our Industry Associations Mission Critical Applications & PACS",
    },
    {
      src: g8,
      desc: "Our Industry Associations Facility Management",
    },
  ];
  var settings = {
    columnCount: {
      default: 4,
      mobile: 3,
      tab: 5,
    },
    mode: "dark",
  };
  return (
    <Wrapper id="pricing">
      <div className="lightBg" style={{ padding: "60px 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold text-center mb-20">
              Channel Partners
            </h1>
            <p>
              As an organization we feel our channel partners play a key role in
              providing our solutions to the markets in India and abroad for
              various sectors. We have an open arm and market oriented partner
              Policies. Our partners are categorized in following categories:
            </p>
            <h3>Industry Associates</h3>
            <p>
              These are our strategic partners who collaborate with us on our
              delivery platforms to provide citizen centric services
              eco-solutions under our various products and services brands.
            </p>
            <br />
            <Lightroom images={images} settings={settings} />
          </HeaderInfo>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  margin-bottom: 50px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
